import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const userStore = {
    actionCreators,
    reducer,
};

export default userStore;
